/**
 * HTMX extension: next-htmx-bs5-ext
 *
 * Intercepts HTMX swaps that target a <next-htmx> element and redirects
 * the response HTML into the Shadow DOM via `setContent()`, instead of
 * letting HTMX write into the light DOM (which would bypass the shadow
 * boundary and break style isolation).
 *
 * Usage:
 *   - The extension auto-attaches to any <next-htmx> with hx-get / hx-post.
 *   - Or manually:  <next-htmx hx-get="/page" hx-ext="next-htmx-bs5-ext">
 */

const EXTENSION_NAME = 'next-htmx-bs5-ext';
const TAG_NAME = 'NEXT-HTMX';

function registerExtension() {
    htmx.defineExtension(EXTENSION_NAME, {
        onEvent(name, evt) {
            if (name !== 'htmx:beforeSwap') return;

            const target = evt.detail.target;
            if (target?.tagName !== TAG_NAME) return;

            // Prevent HTMX's default swap (which would write into light DOM)
            evt.preventDefault();

            // Inject into the Shadow DOM instead
            target.setContent(evt.detail.xhr.responseText);

            // Notify the rest of the HTMX lifecycle
            htmx.trigger(target, 'htmx:afterSwap', evt.detail);
        }
    });
}

/**
 * Auto-attach the extension to every <next-htmx> that uses hx-get or hx-post
 * but doesn't already declare an hx-ext.
 */
function autoAttach() {
    document.querySelectorAll(`next-htmx[hx-get], next-htmx[hx-post]`)
        .forEach(el => {
            if (!el.hasAttribute('hx-ext')) {
                el.setAttribute('hx-ext', EXTENSION_NAME);
            }
        });
}

// --- Init -------------------------------------------------------------------
registerExtension();
document.addEventListener('DOMContentLoaded', autoAttach);